<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="autorization-body__header">
    <p
      v-if="!appState$$.isLogged"
      v-html="homeTexts['autorization']?.['default']"
    />
    <p
      v-else
      v-html="homeTexts['autorization']?.['logged']"
    />
  </div>

  <div class="autorization-body__footer">
    <div
      v-if="isAnnualPass"
      class="autorization-body__footer__keypad"
    >
      <Button
        :class="['bttn-AJ autorization-body__footer__keypad__button', {
          'autorization-body__footer__keypad__button--inactive': isVisibleContentKeypad && isTutorizeMode,
        }]"
        :label="homeTexts['autorization']?.['codeDefaultRegisterButton']"
        tabindex="0"
        @click="onChangeModeRegister(modeRegisterEnum.DEFAULT)"
      />

      <Button
        :class="['bttn-AJ autorization-body__footer__keypad__button', {
          'autorization-body__footer__keypad__button--inactive': isVisibleContentKeypad && !isTutorizeMode,
        }]"
        :label="homeTexts['autorization']?.['codeMinorRegisterButton']"
        tabindex="0"
        @click="onChangeModeRegister(modeRegisterEnum.TUTORIZE)"
      />
    </div>

    <div
      v-if="isVisibleContentKeypad"
      class="autorization-body__footer__content"
    >
      <div class="autorization-body__footer__content__keypad">
        <p
          v-if="isAnnualPass"
          v-html="homeTexts['autorization']?.[`${isTutorizeMode ?
            'codeMinorRegisterDescription' : 'codeDefaultRegisterDescription' }`]"
        />
        <AutorizationKeypad />
      </div>
    </div>
  </div>
</template>

<script setup>
// #region Sttedra
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

// #region Vue
import {
  ref,
  inject,
  computed,
} from 'vue';
// #endregion

// #region Components
import AutorizationKeypad from '@/components/autorization/AutorizationKeypad.vue';
import Button from 'primevue/button/sfc';
// #endregion

// #region Composables
import {useStore} from 'vuex';
import {useRouter} from 'vue-router';
// #endregion

// #region Enums
import {
  modeRegisterEnum,
} from '@/enum/registers.enum';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const router = useRouter();
const store = useStore();
const appState$$ = inject('appState$$');

const isYoungSummer = computed(() => store.getters['app/isYoungSummer']);
const isAnnualPass = computed(() => store.getters['app/isAnnualPass']);
const homeTexts = computed(() => store.getters['text/getSectionTexts']('home'));
const isTutorizeMode = computed(() => store.getters['register/isTutorizeMode']);

const isVisibleContentKeypad = ref(isYoungSummer.value ? true : false);
// #endregion

// #region Functions
/**
 * Handles the change of registration mode.
 *
 * @param {string} isTutorizeRegister - Indicates whether the registration is for a tutorized user.
 */
async function onChangeModeRegister(modeRegister) {
  try {
    // Update application state
    appState$$.isTutorizeRegister = modeRegister === modeRegisterEnum.TUTORIZE;
    await store.dispatch('register/changeMode', modeRegister);
    // Make keypad visible
    isVisibleContentKeypad.value = true;

    const REGISTER_ROUTE_NAME = isTutorizeMode.value ? 'RegisterTutorize' : 'Register';

    if (appState$$.isLogged) {
      appState$$.setLoginApp(true);
      router.push({name: REGISTER_ROUTE_NAME});
    }
  } catch (error) {
    useDev.error('[AutorizationBody.vue] An error occurred in onChangeModeRegister:', error);
  }
}
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.autorization-body {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: $brand__boxspace--medium;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;

  @include media("<=phone") {
    gap: $brand__boxspace--medium * 2;
  }

  &__header {
  max-width: 800px;
    & p {
      text-align: center;
      margin-top: 0;

      @include media("<=phone") {
        font-size: $pv__fs--xlarge--phone;
      }

      @include media(">phone") {
        font-size: $pv__fs--xlarge;
      }
    }
  }

  &__footer {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: $brand__boxspace--medium;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;

    @include media("<=phone") {
      gap: $brand__boxspace--medium * 2;
    }

    &__content{
      max-width: 720px;
    }

    &__keypad{
      display: flex;
      gap: $brand__boxspace--medium;
      justify-content: center;
      @include media("<=phone") {
        flex-direction: column;
      }

      &__button{
        width: 330px;

        @include media("<=phone") {
         width: 300px;
        }

        :deep(.p-button-label){
          font-size: $pv__fs--large--phone;
        }

        &--inactive {
          background-color: grey;
          border-color: $pv__color--grey;
          color: $pv__color--white;
        }
      }
    }

  }
}
</style>
